import { queriesForms } from "@query";

/**
 * Resolves a form instance's own payeeAccountId/payerAccountId — the pair
 * lives on the instance row itself (no engagement lookup needed), so any
 * screen that already has a formId can derive it with this one read.
 */
export const useEmployeeTaxFormsPairFromFormId = (formId: string) => {
  const query = queriesForms.getForm.useQuery(
    { formId },
    { enabled: !!formId }
  );

  return {
    payeeAccountId: query.data?.payeeAccountId,
    payerAccountId: query.data?.payerAccountId,
    isLoading: query.isLoading
  };
};
